export default "__VITE_PUBLIC_ASSET__5146cbf0__"